@if (isMenu) {
  <button mat-menu-item [attr.aria-label]="'retrySending' | translate">
    <mat-icon>redo</mat-icon>
    {{ 'retrySending' | translate }}
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="'retrySending' | translate"
    matTooltip="{{ 'retrySending' | translate }}">
    <mat-icon>redo</mat-icon>
  </button>
}
